<template>
	<div>
		<b-row>
			<b-col cols="12" sm="12" md="12" lg="12" xl="12">
				<h3 class="text-center">{{ curriculum.candidate.name }} {{ curriculum.candidate.surname }}</h3>

				<b-card border-variant="primary" header="General Data" header-bg-variant="default" class="mt-3">
					<b-card-text>
						<b-row class="mb-2">
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>First Name</b> {{ curriculum.candidate.name
								}}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>Last Name</b> {{
								curriculum.candidate.surname }}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>E-mail</b> {{ curriculum.candidate.email
								}}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>Gender Identity </b>
								<span v-if="curriculum.candidate.genderId !== 99">{{ curriculum.candidate.gender.name
									}}</span>
								<span v-else>{{ curriculum.candidate.genderDescription }}</span>
							</b-col>
						</b-row>
						<b-row class="mb-2">
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>Mobile Phone</b> {{
								curriculum.candidate.phoneMobile }}</b-col>
							<b-col v-if="curriculum.candidate.phoneWork" cols="12" sm="3" md="3" lg="3" xl="3"><b>Work
									Phone</b> {{ curriculum.candidate.phoneWork }}</b-col>
							<b-col v-if="curriculum.candidate.phonePrivate" cols="12" sm="3" md="3" lg="3"
								xl="3"><b>Private Phone</b> {{ curriculum.candidate.phonePrivate }}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>Birthday Date</b> {{
								curriculum.candidate.birthPlace | formatDate }} (Age: {{ curriculum.candidate.birthPlace
									| formatAge }})</b-col>
						</b-row>
						<b-row>
							<b-col v-if="curriculum.candidate.currentNationality" cols="12" sm="3" md="3" lg="3"
								xl="3"><b>Nationality</b> {{ curriculum.candidate.currentNationality.name }}</b-col>
							<b-col v-if="curriculum.candidate.cpf" cols="12" sm="3" md="3" lg="3" xl="3"><b>CPF
									(Brazilians only)</b> {{ curriculum.candidate.cpf }}</b-col>
							<b-col v-if="curriculum.candidate.rg" cols="12" sm="3" md="3" lg="3" xl="3"><b>ID / RG /
									Passport</b> {{ curriculum.candidate.rg }}</b-col>
							<b-col v-if="curriculum.candidate.civilState" cols="12" sm="3" md="3" lg="3"
								xl="3"><b>Marital Status</b> {{ curriculum.candidate.civilState.name }}</b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card border-variant="primary" header="Diversity" header-bg-variant="default" class="mt-3">
					<b-card-text>
						<b-row>
							<b-col cols="12" sm="4" md="4" lg="4" xl="4"><b>LGBTQIA+ community</b> {{
								curriculum.candidate.lgbtqia | formatYesNo }}</b-col>
							<b-col v-if="curriculum.candidate.colorRace" cols="12" sm="4" md="4" lg="4"
								xl="4"><b>Color/race</b> {{ curriculum.candidate.colorRace.name }}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>Disability </b>{{
								curriculum.candidate.disability | formatYesNo }} <span
									v-if="curriculum.candidate.disability">({{
										curriculum.candidate.disabilityDescription }})</span>
							</b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card border-variant="primary" header="Address" header-bg-variant="default">
					<b-card-text>
						<b-row class="mb-2">
							<b-col cols="12" sm="6" md="6" lg="6" xl="6"><b>Address</b> {{ curriculum.candidate.address
								}}</b-col>
							<b-col v-if="curriculum.candidate.addressComplement" cols="12" sm="6" md="6" lg="6"
								xl="6"><b>Apartment / Suite / Other</b> {{ curriculum.candidate.addressComplement
								}}</b-col>
						</b-row>
						<b-row>
							<b-col v-if="curriculum.candidate.country" cols="12" sm="3" md="3" lg="3"
								xl="3"><b>Country</b> {{ curriculum.candidate.country.name }}</b-col>
							<b-col v-if="curriculum.candidate.state" cols="12" sm="3" md="3" lg="3" xl="3"><b>State</b>
								{{ curriculum.candidate.state.name }}</b-col>
							<b-col v-if="curriculum.candidate.city" cols="12" sm="3" md="3" lg="3" xl="3"><b>City</b> {{
								curriculum.candidate.city.name }}</b-col>
							<b-col cols="12" sm="3" md="3" lg="3" xl="3"><b>CEP / Zip Code</b> {{
								curriculum.candidate.zipCode }}</b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="curriculum.curriculumRelative.length > 0" border-variant="primary" header="Relatives"
					header-bg-variant="default">
					<b-card-text>
						<b-row class="mb-2">
							<b-table :items="curriculum.curriculumRelative" :fields="relativeFields">
								<template v-slot:cell(unRelative)="row">
									{{ row.item.unRelative | formatYesNo }}
								</template>
								<template v-slot:cell(officeRelative)="row">
									{{ row.item.officeRelative | formatYesNo }}
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card border-variant="primary" header="UN Information" header-bg-variant="default">
					<b-card-text>
						<b-row class="mb-2">
							<b-col cols="12" sm="4" md="4" lg="4" xl="4"><b>Have you ever worked to the UN System?</b>
								{{
									curriculum.workedUnSystem | formatYesNo }} <span
									v-if="curriculum.workedUnSystemAgencyName">({{
										curriculum.workedUnSystemAgencyName }})</span></b-col>
							<b-col cols="12" sm="4" md="4" lg="4" xl="4"><b>Are you a former UN employee?</b> {{
								curriculum.formerUnEmployee | formatYesNo }} <span
									v-if="curriculum.formerUnEmployeeAgencyName">({{
										curriculum.formerUnEmployeeAgencyName }})</span></b-col>
							<b-col cols="12" sm="4" md="4" lg="4" xl="4"><b>Are you a UN System retiree?</b> {{
								curriculum.unSystemRetiree | formatYesNo }} <span
									v-if="curriculum.unSystemRetireeAgencyName">({{
										curriculum.unSystemRetireeAgencyName }})</span></b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="curriculum.workExperience.length > 0" border-variant="primary"
					header="Professional experience" header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table :items="curriculum.workExperience" :fields="experienceFields">
								<template v-slot:cell(salary)="row">
									{{ row.item.salary | formatCurrency }}
								</template>
								<template v-slot:cell(volunteerJob)="row">
									{{ row.item.volunteerJob | formatYesNo }}
								</template>
								<template v-slot:cell(period)="row">
									<b>Start</b> {{ row.item.startDate | formatDate }} <span
										v-if="row.item.endDate"><br><b>End</b> {{ row.item.endDate | formatDate
										}}</span> <span v-if="row.item.onGoing"><br><b>On Going</b></span>
								</template>
								<template v-slot:cell(workDescription)="row">
									<div>{{ row.item.workDescription | escapeHtml }}</div>
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="curriculum.academicQualification.length > 0" border-variant="primary"
					header="Academic Qualification" header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table :items="curriculum.academicQualification" :fields="educationFields">
								<template v-slot:cell(courseDescription)="row">
									<span style="display:block; max-width:600px; word-wrap:break-word;">{{
										row.item.courseDescription }}</span>
								</template>
								<template v-slot:cell(period)="row">
									<b>Start</b> {{ row.item.startDate | formatDate }} <span
										v-if="row.item.endDate"><b>End</b> {{ row.item.endDate | formatDate }}</span>
									<span v-if="row.item.onGoing"><b>On Going</b></span>
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="curriculum.candidateAreaOfExpertise.length > 0" border-variant="primary"
					header="Area of expertise" header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table :items="curriculum.candidateAreaOfExpertise" :fields="expertiseFields">
								<template v-slot:cell(monthOfExperience)="row">
									{{ row.item.monthOfExperience }} month(s)
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>

				<b-card v-if="curriculum.curriculumLanguage.length > 0" border-variant="primary" header="Language"
					header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table :items="curriculum.curriculumLanguage" :fields="languagesFields">
								<template v-slot:cell(description)="row">
									<template>{{ row.item.language.description }} <span
											v-if="row.item.language.id === 99">({{ row.item.other }})</span></template>
								</template>
								<template v-slot:cell(languageLevel)="row">
									<span v-for="(item, index) in sortLanguage(row.item.curriculumLanguageSkill)"
										:key="item.id">
										<template v-if="index !== 0"> / </template>
										<b v-if="item.languageSkill">{{ item.languageSkill.description }}</b>
										<template v-if="item.languageLevel"> {{
											item.languageLevel.description }}</template>
									</span>
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>


				<b-card v-if="curriculum.academicQualification.length > 0" border-variant="primary"
					header="Competencies, Abilities and Soft Skills" header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table :items="curriculum.curriculumCompetencies" :fields="competenciesFields">
								<template v-slot:cell(description)="row">
									<span style="display:block; max-width:600px; word-wrap:break-word;">{{
										row.item.description }}</span>
								</template>
							</b-table>
						</b-row>
					</b-card-text>
				</b-card>


				<b-card v-if="curriculum.curriculumFiles.length" class="card-body">
					<h5 class="card-title">Files</h5>
					<b-row>
						<b-col cols="12" sm="12" md="12" lg="12" xl="12">
							<div class="col-md-12">
								<b-table hover :items="curriculum.curriculumFiles" :fields="fileFields">
									<template v-slot:cell(Options)="row">
										<b-button v-b-tooltip.hover title="Download" variant="success" size="xs"
											@click="downloadFile(row.item.file)"><i
												class="fas fa-download"></i></b-button>
									</template>
								</b-table>
							</div>
						</b-col>
					</b-row>
				</b-card>




			</b-col>
		</b-row>
		<b-row v-if="curriculum.updatedBy">
			<b-col cols="12" class="text-center">
				<p>Modified by <b>{{ curriculum.updatedBy.name }} {{ curriculum.updatedBy.surname }}</b> at {{
					curriculum.updatedAt | formatDateTime }}.</p>
			</b-col>
		</b-row>
	</div>
</template>

<script>

import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'

export default {
	props: {
		curriculum: { type: Object, default: () => ({}) },
		user: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		agency: {
			type: Object,
			required: true,
			default: () => ({}),
		}
	},
	data() {
		return {
			relativeFields: [
				{
					key: 'name',
					label: 'Name'
				},
				{
					key: 'agencyFundProgramme',
					label: 'Agency, Fund or Programme'
				},
				{
					key: 'relative.description',
					label: 'Relative'
				},
				{
					key: 'unRelative',
					label: 'UN Relative'
				},
				{
					key: 'officeRelative',
					label: 'Office Relative'
				}
			],
			languagesFields: [
				{
					key: 'description',
					label: 'Description'
				},
				{
					key: 'languageLevel',
					label: 'Proficiency'
				}
			],
			expertiseFields: [
				{
					key: 'agencyAreaOfExpertise.name',
					label: 'Description'
				},
				{
					key: 'monthOfExperience',
					label: 'Experience'
				}
			],
			educationFields: [
				{
					key: 'courseName',
					label: 'Course'
				},
				{
					key: 'courseDescription',
					label: 'Description'
				},
				{
					key: 'institution',
					label: 'Institution'
				},
				{
					key: 'period',
					label: 'Period'
				},
				{
					key: 'academicType.description',
					label: 'Academic Type'
				},
				{
					key: 'country.name',
					label: 'Country'
				}
			],
			experienceFields: [
				{
					key: 'employer',
					label: 'Employer'
				},
				{
					key: 'position',
					label: 'Position'
				},
				{
					key: 'salary',
					label: 'Annual Salary'
				},
				{
					key: 'period',
					label: 'Period'
				},
				{
					key: 'volunteerJob',
					label: 'Volunteer Job'
				},
				{
					key: 'supervisorName',
					label: 'Supervisor Name'
				},
				{
					key: 'supervisorTitle',
					label: 'Supervisor Title'
				},
				{
					key: 'workDescription',
					label: 'Work Description'
				}
			],

			competenciesFields: [
				{
					key: 'description',
					label: 'Description'
				}
			]
			,
			fileFields: [
				{
					key: 'file.name',
					label: 'Name'
				},
				{
					key: 'file.description',
					label: 'Description'
				},
				{
					key: 'Options',
					label: 'Options',
					thStyle: { 'word-wrap': 'break-word' },
					thClass: 'text-right',
					tdClass: 'text-right'
				}
			],
		}
	},
	methods: {
		...authMethods,
		sortLanguage(arr) {
			return arr.slice().sort(function (a, b) {
				if (a.languageSkill)
					return a.languageSkill.id - b.languageSkill.id;
			})
		},

		downloadFile(item) {
			this.isLoading = true
			var headers = {}
			var url = null
			if (this.public) {
				headers = { 'content-type': 'application/x-www-form-urlencoded' }
				url = appConfig.apiUrl + `public/download/${item.id}`
			} else {
				headers = { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' }
				url = appConfig.apiUrl + `file/download/${item.id}`
			}
			axios.get(url,
				{
					headers: headers,
					responseType: 'blob'
				})
				.then((response) => {
					if (response.data) {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', item.originalName);
						document.body.appendChild(link);
						link.click();
					}
				})
				.catch(error => {
					if (!this.public) {
						this.loginCheck(error.response.status)
					}
					this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
				})
				.finally(() => {
					this.isLoading = false
				})
		},

	}
}
</script>